import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class CobrancaService {

  constructor(
    private http: HttpClient
  ) { }

  obterCobrancasFuturas(contaId) {
    return this.http
      .get(urls.apiBase + '/Cobrancas/ObterCobrancasFuturas?contaId=' + contaId);
  }

  obterCobrancasPorVendaId(id) {
    return this.http
      .get(urls.apiBase + '/Cobrancas/ObterCobrancasPorVendaId?vendaId=' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cobranca/cobranca.service.ts